import {gql} from "@apollo/client";

export const CREATE_CHECKOUT_SESSION = gql`
    mutation CreateCheckoutSession(
        $priceId: String!,
        $successUrl: String!,
        $cancelUrl: String!
        $organizationId: ID
    ) {
        createCheckoutSession(
            priceId: $priceId,
            successUrl: $successUrl,
            cancelUrl: $cancelUrl,
            organizationId: $organizationId
        ) {
            checkoutUrl
        }
    }

`

export const CANCEL_SUBSCRIPTION = gql`
mutation CancelSubscription($stripeSubscriptionId: String!) {
  cancelSubscription(stripeSubscriptionId: $stripeSubscriptionId) {
    success
    message
  }
}
`